<div [class]="isLoading ? 'spinner-overlay show' : 'spinner-overlay hide'">
  <div class="loading-container">
    <div class="loading"></div>
    <div id="loading-text">
      <img src="assets/logo-meds.png" alt="Loading" style="max-width: 90px;">
    </div>
  </div>
</div>
